import React from "react";

const Counter = () => {
  return (
    <section className="counter-section" id="counter">
      <div className="container">
        <div className="row">
          <div className="col-lg-3 col-md-6">
            <div className="counter-block">
              <p className="counter-text">Founded In</p>
              <h1 className="counter-value">2007</h1>
            </div>
          </div>
          <div className="col-lg-3 col-md-6">
            <div className="counter-block">
              <p className="counter-text">Years of Experience</p>
              <h1 className="counter-value and-more">10</h1>
            </div>
          </div>
          <div className="col-lg-3 col-md-6">
            <div className="counter-block">
              <p className="counter-text">Satisfied Clients</p>
              <h1 className="counter-value and-more">100</h1>
            </div>
          </div>
          <div className="col-lg-3 col-md-6">
            <div className="counter-block">
              <p className="counter-text">Industries Explore</p>
              <h1 className="counter-value and-more">20</h1>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Counter;
